<template>
  <!-- //0为不显示状态图，1为没有找到规格图，2为努力加载图，3为检查网络图，4为出错图,5为订单为空 -->
  <div class="robotwrap" v-if="searchStatus !== 0">
    <div v-if="searchStatus === 1">
      <img src="./img/notfind.png" class="robotimg" />
      <div class="robotinfo">没有找到您搜索的规格</div>
      <div class="rttishi">请输入明确的证件照规格名称进行搜索</div>
      <div class="rttishi">如「美国签证」、「四级」、「国考」</div>
      <div class="robotbtn" @click="makerule">自定义规格</div>
    </div>
    <div v-if="searchStatus === 3">
      <img src="./img/neterror.png" class="robotimg" />
      <div class="robotinfo">请检查网络设置或稍后重试</div>
      <div class="robotbtn" @click="refreshfn">刷新一下</div>
    </div>
    <div v-if="searchStatus === 4">
      <img src="./img/error.png" class="robotimg" />
      <div class="robotinfo">哎呀，出错了，刷新重试一下</div>
      <div class="robotbtn" @click="refreshfn">刷新一下</div>
    </div>
    <div v-if="searchStatus === 5">
      <img src="./img/norder.png" class="robotimg" />
      <div class="robotinfo">空空如也，快去拍一张吧！</div>
      <div class="robotbtn" @click="takephoto">拍摄证件照</div>
    </div>
    <div v-if="searchStatus === 6">
      <img src="./img/norder.png" class="robotimg" />
      <div class="robotinfo">{{searchCot}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'searchRule',
  props: {
    searchStatus: {
      type: Number,
      default: 0
    },
    searchCot: {
      type: String,
      default: '空空如也，快分享给团员吧！'
    }
  },
  methods: {
    makerule () {
      console.log('自定义规格')
      this.$emit('goautospec')
    },
    refreshfn () {
      console.log('刷新一下')
    },
    takephoto () {
      console.log('去拍照')
    }
  }
}
</script>

<style scoped>
.robotwrap{
  text-align: center;
  padding: 1.8rem 0 .3rem;
}
.robotimg{
  width:2.4rem;
}
.robotinfo{
  font-size: .28rem;
  color:#303133;
  word-break: break-all;
  margin: .32rem 0;
  font-weight: bold;
}
.rttishi{
  font-size: .24rem;
  color:#303133;
  word-break: break-all;
  white-space: pre-line;
  opacity: 0.4;
}
.robotbtn{
  border-radius: .16rem;
  border:.02rem solid #4710ED;
  font-size: .24rem;
  color:#4710ED;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  width: 2.08rem;
  height:.64rem;
  justify-content: center;
  margin:.48rem auto 0;
}
</style>
